// extracted by mini-css-extract-plugin
module.exports = {"box":"Box_box__EFn_m","boxAccent":"Box_boxAccent__ObGvs","boxTitle":"Box_boxTitle__zUtYX"};